@if (selectOptions.length > 0) {
  <div
    [id]="buttonId"
    class="select"
    (click)="toggleSelectDropdown()"
    >
    <div class="select__content">
      @if (selectedIndex !== -1) {
        <span
          ppTooltip
          [ppTrimTooltip]="true"
          [ppChildTooltip]="true"
          [ppTitle]="selectOptions[selectedIndex].label"
          class="fleetAccountSelect__content"
          >
          {{ selectOptions[selectedIndex].label }}
        </span>
      }
      @if (selectedIndex === -1) {
        <span class="fleetAccountSelect__placeholder">
          {{ 'select_a_fleet' | ppTranslate }}
        </span>
      }
    </div>
    <div class="select__caret">
      <div class="select__icon-container">
        <pp-icon
        [ppSrc]="
          dropdown.visible && dropdown.buttonId === buttonId
            ? EIconPath.ICON_MISC_UP_ARROW_18
            : EIconPath.ICON_MISC_DOWN_ARROW_18
        "
          ppColor="grey-400"
          ppClass="setSize18"
        ></pp-icon>
      </div>
    </div>
  </div>
}
